import { useNavigate } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const AboutPage = () => {
  const navigate = useNavigate();
  const team = [
    { name: 'Ahmed Radi', role: 'Chief Executive Officer', img: 'https://storage.readdy-site.link/project_files/6746c619-ced5-4466-9905-8e7d3536934a/2b33847e-c0d8-46d0-8e91-66b940c3c803_me-2.jpeg?v=18c8dbe6beac86d6363ef16b7ce0052f' },
    { name: 'Sarah Nguyen', role: 'Chief Operations Officer', img: 'https://public.readdy.ai/ai/img_res/e78b074ae98cf280a4143959e80bb6cd.jpg' },
    { name: 'David Hartwell', role: 'VP of Operations', img: 'https://readdy.ai/api/search-image?query=Professional%20male%20VP%20operations%20executive%20corporate%20headshot%20clean%20background%20business%20casual%20natural%20lighting%20professional%20portrait%20confident%20smile&width=300&height=300&seq=vp-ops-renova&orientation=squarish' },
    { name: 'Jennifer Walsh', role: 'VP of Customer Experience', img: 'https://readdy.ai/api/search-image?query=Professional%20female%20VP%20customer%20experience%20executive%20corporate%20headshot%20clean%20background%20business%20attire%20natural%20lighting%20professional%20portrait%20friendly%20smile&width=300&height=300&seq=vp-cx-renova&orientation=squarish' },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <section className="bg-[#0C2340] py-20 nav-offset">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-[#C41E3A] text-sm font-bold uppercase tracking-widest mb-3">About Us</p>
          <h1 className="text-4xl md:text-6xl font-bold text-white mb-5">Built to Scale. Built to Last.</h1>
          <p className="text-xl text-white/75 max-w-3xl mx-auto">Renova is building the modern home services company, full-service, technology-driven, and designed to serve Florida homeowners at the highest level.</p>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-16 items-center mb-20">
            <div>
              <h2 className="text-3xl md:text-4xl font-bold text-[#111827] mb-6">Our Mission</h2>
              <p className="text-lg text-[#6B7280] mb-5 leading-relaxed">
                Renova is a full-service home comfort and energy solutions company specializing in heating, cooling, plumbing, electrical, and energy efficiency upgrades. We provide installation, service, maintenance, and financing solutions for homeowners and businesses across Florida.
              </p>
              <p className="text-lg text-[#6B7280] mb-8 leading-relaxed">
                We believe every homeowner deserves access to professional, reliable home services at transparent prices, with flexible financing, protection plans, and expert guidance at every step.
              </p>
              <div className="grid grid-cols-2 gap-4">
                {[
                  { val: '2018', label: 'Founded' },
                  { val: 'Florida', label: 'Current Territory' },
                  { val: '500+', label: 'Technicians' },
                  { val: '50,000+', label: 'Homes Served' },
                ].map((s) => (
                  <div key={s.label} className="bg-[#F8F9FB] rounded-xl p-5 border border-[#E2E8F0]">
                    <p className="text-3xl font-bold text-[#C41E3A] mb-1">{s.val}</p>
                    <p className="text-sm text-[#6B7280]">{s.label}</p>
                  </div>
                ))}
              </div>
            </div>
            <div className="relative rounded-2xl overflow-hidden h-[500px]">
              <img
                alt="Renova team and company overview"
                className="w-full h-full object-cover object-center"
                src="https://readdy.ai/api/search-image?query=Modern%20clean%20professional%20home%20services%20company%20office%20headquarters%20bright%20white%20interior%20team%20working%20collaborative%20open%20workspace%20corporate%20startup%20technology%20driven%20company%20premium%20professional%20environment&width=700&height=500&seq=about-renova&orientation=portrait"
              />
            </div>
          </div>

          <div className="mb-20">
            <h2 className="text-3xl font-bold text-[#111827] mb-10 text-center">Leadership Team</h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
              {team.map((m) => (
                <div key={m.name} className="text-center">
                  <div className="w-24 h-24 rounded-full overflow-hidden mx-auto mb-4 border-2 border-[#E2E8F0]">
                    <img alt={m.name} className="w-full h-full object-cover object-top" src={m.img} />
                  </div>
                  <h3 className="text-base font-bold text-[#111827]">{m.name}</h3>
                  <p className="text-sm text-[#6B7280] mt-1">{m.role}</p>
                </div>
              ))}
            </div>
          </div>

          <div id="acquisition" className="bg-[#0C2340] rounded-2xl p-10 md:p-16">
            <div className="max-w-3xl mx-auto text-center">
              <p className="text-[#C41E3A] text-sm font-bold uppercase tracking-widest mb-3">Acquisitions &amp; Partnerships</p>
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">Grow With Renova</h2>
              <p className="text-lg text-white/70 mb-8 leading-relaxed">
                Renova actively acquires and partners with established home service businesses. We provide capital, brand, technology, and national infrastructure while preserving what makes local operators great: their expertise, reputation, and team.
              </p>
              <div className="grid md:grid-cols-3 gap-6 mb-8">
                {[
                  { icon: 'ri-merge-cells-horizontal', title: 'Acquisitions', desc: 'Full or partial acquisition of HVAC, plumbing, and electrical businesses.' },
                  { icon: 'ri-handshake-line', title: 'Partnerships', desc: 'Joint venture and referral partnership programs.' },
                  { icon: 'ri-expand-diagonal-line', title: 'Scale Support', desc: 'Access capital, brand, and infrastructure to grow faster.' },
                ].map((item) => (
                  <div key={item.title} className="bg-white/8 border border-white/10 rounded-xl p-6">
                    <div className="w-10 h-10 bg-[#C41E3A]/20 rounded-lg flex items-center justify-center mx-auto mb-3">
                      <i className={`${item.icon} text-xl text-[#C41E3A]`} />
                    </div>
                    <h3 className="text-sm font-bold text-white mb-1">{item.title}</h3>
                    <p className="text-xs text-white/60">{item.desc}</p>
                  </div>
                ))}
              </div>
              <button onClick={() => navigate('/contact')} className="bg-[#C41E3A] text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-[#A01830] transition-colors whitespace-nowrap cursor-pointer">
                Start the Conversation
              </button>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default AboutPage;
